module.exports = __webpack_public_path__ + "media/application/images/banner-good-stories-2c41d42a01ec2c919d49be6a4911af2c.png";